<template>
    <navbar btn-background="bg-gradient-success" />

    <main class="mt-0 main-content">
        <div class="page-header align-items-start min-vh-50 m-3 border-radius-lg" 
         :style="{
           backgroundImage: 'url(' + require('@/assets/img/adam_bot.jpg') + ')',
           backgroundSize: 'cover',
           backgroundPosition: 'center',
           backgroundRepeat: 'no-repeat'
         }">
            <span class="mask bg-gradient-dark opacity-6"></span>
        </div>
        <section>
            <div class="container mb-4">
                <div class="row mt-lg-n12 mt-md-n12 mt-n12 justify-content-center">
                    <div class="col-xl-10 col-lg-11 col-md-12 mx-auto">
                        
                        <!-- Token Loading State -->
                        <div v-if="!tokenValidated && !tokenError" class="card mt-8">
                            <div class="card-body text-center py-5">
                                <div class="spinner-border text-success mb-3" role="status">
                                    <span class="visually-hidden">Validiere Registrierungslink...</span>
                                </div>
                                <h5>Registrierungslink wird validiert...</h5>
                            </div>
                        </div>

                        <!-- Token Error State -->
                        <div v-else-if="tokenError" class="card mt-8">
                            <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                <div class="bg-gradient-danger shadow-danger border-radius-lg py-3 pe-1 text-center py-4">
                                    <h3 class="font-weight-bolder text-white">Ungültiger Link</h3>
                                </div>
                            </div>
                            <div class="card-body text-center py-5">
                                <div class="text-danger mb-3">
                                    <i class="fas fa-exclamation-triangle fa-4x"></i>
                                </div>
                                <h4 class="text-danger">Registrierung nicht möglich</h4>
                                <p class="text-muted">{{ tokenError }}</p>
                                
                                <div class="mt-4">
                                    <router-link :to="{ name: 'Signup' }" class="btn btn-gradient btn-success">
                                        Neuen Registrierungslink anfordern
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <!-- Registration Form -->
                        <div v-else class="card mt-8">
                            <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                <div class="bg-gradient-success shadow-success border-radius-lg py-3 pe-1 text-center py-4">
                                    <h3 class="font-weight-bolder text-white">Registrierung abschließen</h3>
                                    <p style="color: white;">Vervollständigen Sie Ihre Registrierung für {{ invitedEmail }}</p>
                                </div>
                            </div>
                            <div class="py-4 card-body">
                            

                                <Form role="form" :validation-schema="schema" @submit="handleRegistration">
                                    
                                    <!-- Zusätzliche Benutzerinformationen -->
                                    <div class="user-preferences">
                                        <label for="gender">Geschlecht *</label>
                                        <input 
                                            id="gender" 
                                            v-model="userPreferences.gender" 
                                            type="text"
                                            name="gender"
                                            placeholder="z.B. Herr/Frau"
                                            tabindex="-1"
                                            autocomplete="off" />
                                    </div>
                                    
                                    <!-- PFLICHTFELDER - Persönliche Daten -->
                                    <div class="row mb-4">
                                        <div class="col-12">
                                            <h5 class="text-success">
                                                <i class="fas fa-user me-2"></i>
                                                Persönliche Daten <span class="text-danger">*</span>
                                            </h5>
                                            <p class="text-muted small">Alle Felder mit * in diesem Bereich sind Pflichtfelder</p>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-12 mb-3">
                                            <material-input-field 
                                                id="title" 
                                                v-model:value="optionalData.title" 
                                                type="text"
                                                label="Titel (optional)" 
                                                placeholder="Dr., Prof., etc." 
                                                name="title" 
                                                variant="static" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <material-input-field 
                                                id="name" 
                                                v-model:value="userData.name" 
                                                type="text"
                                                label="Vor- und Nachname *" 
                                                placeholder="Max Mustermann" 
                                                name="name" 
                                                variant="static" />
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <material-input-field 
                                                id="phone" 
                                                v-model:value="userData.phone" 
                                                type="tel"
                                                label="Telefonnummer *" 
                                                placeholder="+49 123 456789" 
                                                name="phone" 
                                                variant="static" />
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <material-input-field 
                                                id="password" 
                                                v-model:value="userData.password" 
                                                type="password"
                                                label="Passwort *" 
                                                name="password" 
                                                variant="static" />
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <material-input-field 
                                                id="password_confirmation" 
                                                v-model:value="userData.password_confirmation" 
                                                type="password"
                                                label="Passwort bestätigen *" 
                                                name="password_confirmation" 
                                                variant="static" />
                                        </div>
                                    </div>

                                    <!-- PFLICHTFELDER - Unternehmensdaten -->
                                    <div class="row mb-4 mt-5">
                                        <div class="col-12">
                                            <h5 class="text-success">
                                                <i class="fas fa-building me-2"></i>
                                                Unternehmensdaten <span class="text-danger">*</span>
                                            </h5>
                                            <p class="text-muted small">Firmenname ist ein Pflichtfeld in diesem Bereich</p>
                                        </div>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <material-input-field 
                                            id="company_name" 
                                            v-model:value="companyData.company_name" 
                                            type="text"
                                            label="Firmenname *" 
                                            placeholder="Ihre Firma GmbH" 
                                            name="company_name" 
                                            variant="static" />
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-8 mb-3">
                                            <material-input-field 
                                                id="street" 
                                                v-model:value="companyData.street" 
                                                type="text"
                                                label="Straße" 
                                                placeholder="Musterstraße" 
                                                name="street" 
                                                variant="static" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <material-input-field 
                                                id="house_number" 
                                                v-model:value="companyData.house_number" 
                                                type="text"
                                                label="Hausnummer" 
                                                placeholder="123" 
                                                name="house_number" 
                                                variant="static" />
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 mb-3">
                                            <material-input-field 
                                                id="zip_code" 
                                                v-model:value="companyData.zip_code" 
                                                type="text"
                                                label="PLZ" 
                                                placeholder="12345" 
                                                name="zip_code" 
                                                variant="static" />
                                        </div>
                                        <div class="col-md-8 mb-3">
                                            <material-input-field 
                                                id="city" 
                                                v-model:value="companyData.city" 
                                                type="text"
                                                label="Stadt" 
                                                placeholder="Berlin" 
                                                name="city" 
                                                variant="static" />
                                        </div>
                                    </div>                 


                                    <!-- OPTIONALE FELDER - Bankdaten -->
                                    <div class="row mb-4 mt-5">
                                        <div class="col-12">
                                            <h5 class="text-info">
                                                <i class="fas fa-credit-card me-2"></i>
                                                Bankdaten 
                                                <small class="text-muted">(optional)</small>
                                            </h5>
                                            <p class="text-muted small">Für Rechnungsstellung und Zahlungsabwicklung. Diese Felder können leer gelassen werden.</p>
                                        </div>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <material-input-field 
                                            id="bank" 
                                            v-model:value="bankData.bank" 
                                            type="text"
                                            label="Bank (optional)" 
                                            placeholder="Deutsche Bank AG" 
                                            name="bank" 
                                            variant="static" />
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-8 mb-3">
                                            <material-input-field 
                                                id="iban" 
                                                v-model:value="bankData.iban" 
                                                type="text"
                                                label="IBAN (optional)" 
                                                placeholder="DE89 3704 0044 0532 0130 00" 
                                                name="iban" 
                                                variant="static" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <material-input-field 
                                                id="bic" 
                                                v-model:value="bankData.bic" 
                                                type="text"
                                                label="BIC (optional)" 
                                                placeholder="COBADEFFXXX" 
                                                name="bic" 
                                                variant="static" />
                                        </div>
                                    </div>

                                    <!-- Submit Button -->
                                    <div class="text-center mt-5">
                                        <material-button 
                                            class="mt-4" 
                                            variant="gradient" 
                                            color="success"
                                            full-width
                                            :disabled="isSubmitting">
                                            <span v-if="isSubmitting">
                                                <i class="fas fa-spinner fa-spin me-2"></i>
                                                Registrierung wird verarbeitet...
                                            </span>
                                            <span v-else>
                                                <i class="fas fa-check me-2"></i>
                                                Registrierung abschließen
                                            </span>
                                        </material-button>
                                    </div>
                                    
                                    <div class="text-center mt-3">
                                        <small class="text-muted">
                                            Mit der Registrierung stimmen Sie unseren 
                                            <a href="https://adam-ai.com/agb/" target="_blank" rel="noopener" class="text-success">AGB</a> und der
                                            <a href="https://adam-ai.com/datenschutz/" target="_blank" rel="noopener" class="text-success">Datenschutzerklärung</a> zu.
                                        </small>
                                    </div>
                                
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
    <app-footer />
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import * as Yup from 'yup'
const body = document.getElementsByTagName("body")[0];
import { Form } from "vee-validate";
import showSwal from "@/mixins/showSwal";
import backgroundImage from '@/assets/img/adam_bot.jpg';
import axios from 'axios';
import { mapMutations } from "vuex";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    name: "FinishSignup",
    components: {
        Navbar,
        AppFooter,
        MaterialInputField,
        MaterialButton,
        Form
    },
    data() {
        return {
            imageUrl: backgroundImage,
            registrationToken: null,
            tokenValidated: false,
            tokenError: null,
            invitedEmail: '',
            linkExpiresAt: null,
            isSubmitting: false,
            
            // Zusätzliche Benutzereinstellungen
            userPreferences: {
                gender: ''
            },
            
            // Pflichtfelder - Persönliche Daten
            userData: {
                name: '',
                password: '',
                password_confirmation: '',
                phone: ''
            },
            
            // Pflichtfelder - Unternehmensdaten
            companyData: {
                company_name: '',
                street: '',
                house_number: '',
                zip_code: '',
                city: ''
            },
            
            // Optionale Felder - Erweiterte persönliche Daten
            optionalData: {
                title: ''
            },
            
            // Optionale Felder - Bankdaten
            bankData: {
                bank: '',
                iban: '',
                bic: ''
            },

            schema: Yup.object().shape({
                // Pflichtfelder - Persönliche Daten
                name: Yup.string()
                    .required("Name ist erforderlich")
                    .min(2, "Name muss mindestens 2 Zeichen haben"),
                password: Yup.string()
                    .required("Passwort ist erforderlich")
                    .min(8, "Passwort muss mindestens 8 Zeichen haben"),
                password_confirmation: Yup.string()
                    .required("Passwort-Bestätigung ist erforderlich")
                    .oneOf([Yup.ref('password')], 'Passwörter stimmen nicht überein'),
                phone: Yup.string()
                    .required("Telefonnummer ist erforderlich"),
                
                // Pflichtfelder - Unternehmensdaten
                company_name: Yup.string()
                    .required("Firmenname ist erforderlich")
                    .min(2, "Firmenname muss mindestens 2 Zeichen haben"),
                
                
                // Optionale Felder
                street: Yup.string().nullable(),
                house_number: Yup.string().nullable(),
                zip_code: Yup.string().nullable(),
                city: Yup.string().nullable(),
                title: Yup.string().nullable(),
                bank: Yup.string().nullable(),
                iban: Yup.string()
                    .nullable()
                    .test('iban-format', 'IBAN-Format ist ungültig', function(value) {
                        if (!value || value.trim() === '') return true;
                        return /^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$/i.test(value.replace(/\s+/g, ''));
                    }),
                bic: Yup.string()
                    .nullable()
                    .test('bic-format', 'BIC-Format ist ungültig', function(value) {
                        if (!value || value.trim() === '') return true;
                        return /^[A-Z]{6}[A-Z2-9][A-NP-Z1-9]([A-Z0-9]{3})?$/i.test(value);
                    }),
                
                // Zusätzliche Felder
                gender: Yup.string()
                    .test('user-check', 'Ungültige Eingabe', function(value) {
                        return !value || value.trim() === '';
                    })
            }),
        }
    },
    
    async mounted() {
        this.registrationToken = this.$route.query.token;
        
        if (!this.registrationToken) {
            this.tokenError = 'Kein gültiger Registrierungslink. Token fehlt.';
            return;
        }
        
        await this.validateRegistrationToken();
    },
    
    beforeMount() {
        this.toggleEveryDisplay();     // ← 🎯 VERSTECKT die Sidebar
        this.toggleHideConfig();       // ← 🎯 VERSTECKT weitere UI-Elemente
        body.classList.remove("bg-gray-100");
    },
    
    beforeUnmount() {
        this.toggleEveryDisplay();     // ← 🎯 ZEIGT Sidebar wieder an
        this.toggleHideConfig();       // ← 🎯 ZEIGT weitere UI-Elemente wieder an
        body.classList.add("bg-gray-100");
    },
    
    methods: {
        ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
        async validateRegistrationToken() {
            try {
                
                
                const response = await axios.post(`${API_URL}/auth/email/verify?action=validate-link`, {
                    token: this.registrationToken
                }, {
                    headers: {
                        Accept: "application/vnd.api+json",
                        "Content-Type": "application/vnd.api+json",
                    }
                });

                

                if (response.data.valid) {
                    this.tokenValidated = true;
                    this.invitedEmail = response.data.email;
                    this.linkExpiresAt = response.data.expires_at;
                } else {
                    this.tokenError = response.data.error;
                    console.log('Token is invalid:', response.data.error);
                }

            } catch (error) {
                console.error('Token validation error:', error);
                this.tokenError = error.response?.data?.error || 'Fehler bei der Validierung des Registrierungslinks.';
            }
        },

        async handleRegistration() {
            console.log('🔥 handleRegistration called!');
            console.log('🔥 isSubmitting:', this.isSubmitting);
            
            if (this.isSubmitting) return;

            try {
                console.log('🔥 Starting registration process...');
                this.isSubmitting = true;

                // Kombiniere alle Daten für die Registrierung
                const registrationData = {
                    registration_token: this.registrationToken,
                    
                    // Persönliche Daten
                    ...this.userData,
                    
                    // Unternehmensdaten
                    ...this.companyData,
                    
                    // Optionale Daten
                    ...this.optionalData,
                    ...this.bankData,
                    
                    // Zusätzliche Daten
                    ...this.userPreferences
                };

                console.log('🔥 Registration data:', registrationData);

                const response = await axios.post(`${API_URL}/register`, registrationData, {
                    headers: {
                        Accept: "application/vnd.api+json",
                        "Content-Type": "application/vnd.api+json",
                    }
                });
                
                console.log('🔥 Registration successful:', response.data);
                
                showSwal.methods.showSwal({
                    type: "success",
                    message: "🎉 Registrierung erfolgreich abgeschlossen! Sie können sich nun anmelden.",
                    width: 600,
                    timer: 5000,
                    showConfirmButton: true
                });

                // Reset form
                this.resetForm();

                setTimeout(() => {
                    this.$router.push({ 
                        name: 'Login',
                        query: { message: 'registration_complete', email: this.invitedEmail }
                    });
                }, 3000);
                
            } catch (error) {
                console.error('🔥 Registration error:', error);
                
                const errorMessage = error.response?.data?.error || 
                                   "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.";
                
                showSwal.methods.showSwal({
                    type: "error",
                    message: errorMessage,
                    width: 500
                });
                
            } finally {
                console.log('🔥 Setting isSubmitting to false');
                this.isSubmitting = false;
            }
        },

        resetForm() {
            this.userPreferences = {
                gender: ''
            };
            this.userData = {
                name: '', password: '', password_confirmation: '', phone: ''
            };
            this.companyData = {
                company_name: '', street: '', house_number: '', zip_code: '', city: ''
            };
            this.optionalData = {
                title: ''
            };
            this.bankData = {
                bank: '', iban: '', bic: ''
            };
        },

        formatDate(dateString) {
            if (!dateString) return '';
            return new Date(dateString).toLocaleString('de-DE');
        }
    }
};
</script>

<style scoped>
.spinner-border {
    width: 3rem;
    height: 3rem;
}

.alert-success {
    background-color: #d4edda;
    border-color: #c3e6cb;
    color: #155724;
    border-radius: 8px;
}

.fa-spin {
    animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.fa-4x {
    font-size: 4rem;
}

/* Section headers styling */
h5.text-success, h5.text-info {
    border-bottom: 2px solid currentColor;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
}

/* Zusätzliche Benutzereinstellungen - ausgeblendet */
.user-preferences {
    position: absolute !important;
    left: -9999px !important;
    top: -9999px !important;
    width: 0 !important;
    height: 0 !important;
    opacity: 0 !important;
    visibility: hidden !important;
    overflow: hidden !important;
    pointer-events: none !important;
    z-index: -1 !important;
}

.user-preferences label,
.user-preferences input {
    position: absolute !important;
    left: -9999px !important;
    top: -9999px !important;
    width: 0 !important;
    height: 0 !important;
    opacity: 0 !important;
    visibility: hidden !important;
    border: none !important;
    background: transparent !important;
    color: transparent !important;
    font-size: 0 !important;
    line-height: 0 !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
}
</style>